<template>
  <spot
    :ctype="tvspot.ctype"
    :enable-edit-overlay-data-shortcut="enableEditOverlayDataShortcut"
    :has-multiple-formats="bundle.has_multiple_formats"
    :highlight-title-when-selected="highlightTitleWhenSelected"
    :highlight-title="highlightTitle"
    :no-content-selection-placeholder="noContentSelectionPlaceholder"
    :on-click-spot-id="bundle.id"
    :on-click="onClick"
    :override-is-on-air="bundle.is_on_air"
    :override-title="mainTVSpot.title"
    :show-content-selection-checkbox="showContentSelectionCheckbox"
    :show-date="showDate"
    :show-divider="showDivider"
    :show-new-badge="showNewBadge"
    :spot="tvspot"
  >
    <!-- Pass through own optional slots to child component's slots -->
    <div slot="actions">
      <slot name="actions" />
    </div>
    <div
      v-if="showTvformatNames"
      slot="subtitle"
    >
      <span
        v-for="(bundleTvspot, bundleTvspotIndex) in bundle.tvspots"
        :key="bundleTvspot.id + '_tvformat'"
        :title="
          $t('bundleShowTvFormatPrefix') + ': ' + bundleTvspot.tvformat.name
        "
      >
        {{ bundleTvspot.tvformat.name }}
        <span v-if="bundleTvspotIndex < bundle.tvspots.length - 1">,</span>
      </span>
    </div>
  </spot>
</template>

<script>
import {
  getMainTVSpotFromBundle,
  getMatchingTVSpotForBundleAndTVDecoder,
} from '@/utils';

import Spot from '@/components/Spot';

export default {
  components: {
    Spot,
  },
  props: {
    /** Serialized TVSpotBundle object. */
    bundle: {
      type: Object,
      required: true,
    },
    /**
     * Optional serialized TVDecoder.
     *
     * When given, the TVSpot used will the one that matches the
     * TVDecoder's TVFormat, when available, main_tvspot otherwise.
     */
    decoder: {
      type: Object,
      default: null,
    },
    /** A few props are just passed through to the Spot component. */
    onClick: {
      type: Function,
      default: null,
    },
    highlightTitle: {
      type: Boolean,
      default: false,
    },
    highlightTitleWhenSelected: {
      type: Boolean,
      default: true,
    },
    showNewBadge: {
      type: Boolean,
      default: true,
    },
    showDate: {
      type: Boolean,
      default: false,
    },
    showTvformatNames: {
      type: Boolean,
      default: false,
    },
    showContentSelectionCheckbox: {
      type: Boolean,
      default: false,
    },
    noContentSelectionPlaceholder: {
      type: Boolean,
      default: false,
    },
    showDivider: {
      type: Boolean,
      default: false,
    },
    enableEditOverlayDataShortcut: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasActionsSlot() {
      return !!this.$slots.actions;
    },
    mainTVSpot() {
      return getMainTVSpotFromBundle(this.bundle);
    },
    /**
     * Return matching TVSpot for optional TVDecoder or the main_tvspot.
     */
    tvspot() {
      if (this.decoder && this.decoder.id) {
        const matchingTVSpot = getMatchingTVSpotForBundleAndTVDecoder(
          this.bundle,
          this.decoder
        );
        return matchingTVSpot || this.mainTVSpot;
      }
      return this.mainTVSpot;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TvSpotBundle.vue